import { useState } from "react";
import Popover from "@material-ui/core/Popover";
import HelpOutlineRoundedIcon from "@material-ui/icons/HelpOutlineRounded";

import "./Help.scss";

interface HelpProps {
  content: string;
  style?: {};
}

export const Help = (props: HelpProps) => {
  const { content, style } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);

  return (
    <div className="help">
      <div
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        className={`help__btn ${!!anchorEl ? "help__btn--active" : ""}`}
      >
        <HelpOutlineRoundedIcon />
      </div>
      <Popover
        id="serrana-inv-model-edit"
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        style={style || { zIndex: 501, marginTop: "0.5rem" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="help__content">
          <p className="help__content-p">{content}</p>
        </div>
      </Popover>
    </div>
  );
};
